export function isGif(url) {
    return /\.(gif)$/.test(url);
}
